import { ISetup } from "@smartrr/shared/entities/Organization";
import { GettingStartedStep } from "../GettingStartedStep";
import { MigrationStep } from "../MigrationStep";
import { SubscriptionProgramStep } from "../SubscriptionProgramStep";
import { SubscriptionBlockStep } from "../SubscriptionBlockStep";
import { CustomerPortalStep } from "../CustomerPortalStep";

export class GettingStartedStepFactory {
  setup: ISetup;

  constructor(setup: ISetup) {
    this.setup = setup;
  }

  generateSteps(): GettingStartedStep[] {
    return [
      new MigrationStep(this.setup),
      new SubscriptionProgramStep(this.setup),
      new SubscriptionBlockStep(this.setup),
      new CustomerPortalStep(this.setup),
    ];
  }
}
